<template>
    <v-btn v-if="!isGuest"
		   ref="download-xmp-button"
		   :disabled="!canExportXMP || !image || IDT.initial || blockLoading"
           @click="onClick"
           v-tippy="{placement: 'left'}"
           content="Download XMP Profile"
    >
        <img src="/assets/icons/lr-icon-96x96.png" />
    </v-btn>
</template>

<script>
import CanMixin from "@/mixins/CanMixin";
import FilenameMixin from "@/mixins/Filename";
import { mapGetters, mapState } from "vuex";

export default {
    mixins: [CanMixin, FilenameMixin],
    computed: {
        ...mapState("App", ["IDT", "blockLoading"]),
        ...mapState("Projects", ['image', 'currentFile']),
        ...mapState("UI", ['startTips', 'showAddMatchTooltip']),
        ...mapGetters('User', ['isGuest']),
    },
    mounted() {
        this.$root.$refs.downloadXMPButton = this.$refs['download-xmp-button'];
    },
    methods: {
        onClick() {
            if (!this.canExportXMP || !this.image || this.IDT.initial || this.blockLoading) return;
            // if (lutify.isCurrentPlanFree()) {
            //     UI.showModal(UI.modals.notAvailableInFree.el);
            //     return;
            // }

            this.$store.dispatch('UI/setRightColumn', 'download-xmp')
		}
	}
}
</script>

<style lang="scss" scoped>
.v-btn--disabled {
    img {
        opacity: 0.4;
    }
}

img {
    width: 20px;
}
</style>